
// Imports
import { Injectable }     from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';



import {apiUrl} from '../shared/config';
import {Respond} from '../shared/respond';
import {PostBody} from '../shared/postBody';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class XhrService {
    respond:Respond;
     token:string;
     // Resolve HTTP using the constructor
     constructor (private http: Http) {
         
         if(window.localStorage.getItem('Token')){
            this.token=window.localStorage.getItem('Token');
         }else{
            this.token='';
         }
         
         
         
     }

     // Fetch all existing comments
     get(path:string) : Observable<any>{
         // ...using get request
         
         let url =apiUrl+path+'?Token='+this.token;
         return this.http.get(url)
                        // ...and calling .json() on the response to return data
                         .map((res:Response) =>{
                             this.respond = res.json();
                             //console.log(this.respond);
                             if(this.respond.success && this.respond.message && this.respond.message.items){
                                     return this.respond.message.items;
                             }else{
                                 
                                 throw new Error(JSON.stringify(this.respond.errors));
                             }
                             
                         } )
                         //...errors if any
                         .catch((error:any) => {
                             var message;
                            if(error.message){
                                 message = JSON.parse(error.message).error;
                             }else{
                                 message = {
                                     code:'404',
                                     heading:"connection",
                                     message:'server down'
                                 }
                             }
                             return Observable.throw(message)
                         });
        
     }

     // Add a new comment
    post (path:string,postData: PostBody): Observable<any> {
        let bodyString = JSON.stringify(postData); // Stringify payload
        //let headers = new Headers({ 'Content-Type': 'multipart/form-data;' }); // ... Set content type to JSON
        //let options = new RequestOptions({ headers: headers }); // Create a request option
        
        var formData = new FormData();
        var files = $('.aqFile');
        for(let i =0;i<files.length;i++){
            if (files[i]['files'].length > 0) {
                    formData.append($(files[i]).attr('id'),files[i]['files'][0]);
                }
        }
       
        formData.append("postData", bodyString);
        let url =apiUrl+path+'?Token='+this.token;
        return this.http.post(url, formData) // ...using post request
                         // ...and calling .json() on the response to return data
                         .map((res:Response) =>{
                             this.respond = res.json();
                             //console.log(this.respond);
                             if(this.respond.success && this.respond.message && this.respond.message.items){
                                     return this.respond.message.items;
                             }else{
                                 
                                 throw new Error(JSON.stringify(this.respond.errors));
                             }
                             
                         } )
                         //...errors if any
                         .catch((error:any) => {
                             var message;
                             if(error.message){
                                 
                                 message = JSON.parse(error.message).error;
                             }else{
                                 message = {
                                     code:'404',
                                     heading:"connection",
                                     message:'server down'
                                 }
                             }
                             return Observable.throw(message)
                         });
    }   

    
}



// WEBPACK FOOTER //
// ./src/app/service/xhr.service.ts